export default function SubscriptionsState(state = {
    subscriptions: { search_string: '', list: {}, details: {}, validation: {}, options: {}, filter: {} }
}, action) {
    switch (action.type) {
        case 'SUBSCRIPTIONS_UPDATE_SEARCH_STRING':
            state.subscriptions.search_string = action.value;
            return { ...state };
        case "SUBSCRIPTIONS_UPDATE_FILTER_STRING":
            state.subscriptions.filter = action.value;
            return { ...state };
        case 'SUBSCRIPTIONS_SEARCH':
            state.subscriptions.list = action.data.list;
            return { ...state };
        case 'SUBSCRIPTIONS_OPTIONS':
            state.subscriptions.options = action.data.options;
            return { ...state };
        case 'SUBSCRIPTIONS_DETAILS':
            state.subscriptions.details = action.data.record;
            return { ...state };
        case 'SUBSCRIPTIONS_UPDATE_FORM':
            state.subscriptions.details[action.field] = action.value;
            if (state.subscriptions.validation[action.field]) {
                state.subscriptions.validation[action.field] = {};
            }
            return { ...state };
        case 'SUBSCRIPTIONS_VALIDATION_ERROR':
            state.subscriptions.validation = action.data;
            return { ...state };
        case 'SUBSCRIPTIONS_SELECTED':
            state.subscriptions.selected = action.value;
            state.subscriptions.details = {};
            state.subscriptions.validation = {};
            return { ...state };
        case 'SUBSCRIPTIONS_DESELECTED':
        case 'SUBSCRIPTIONS_UPDATED':
        case 'SUBSCRIPTIONS_INSERTED':
        case 'SUBSCRIPTIONS_DELETED':
            state.subscriptions.selected = null;
            state.subscriptions.details = {};
            state.subscriptions.validation = {};
            return { ...state };
        case 'SUBSCRIPTIONS_CANCEL_SELECT':
            state.subscriptions.selected = null;
            return { ...state };
        case 'SUBSCRIPTIONS_INSERT_ERROR':
        case 'SUBSCRIPTIONS_UPDATE_ERROR':
            state.subscriptions = {};
            return { ...state };
        default:
            break;
    }
    return state;
}

